import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminPanel from '../components/AdminPanel';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

const AdminPage: React.FC = () => {
  const { user, token } = useAuth();
  
  // Get super admin token from environment (optional)
  const superAdminToken = process.env.REACT_APP_SUPER_ADMIN_TOKEN;
  
  // Define super admin emails (should match backend)
  const SUPER_ADMIN_EMAILS = ['c.grant@scientistintheloop.com'];
  
  // Check if user has admin role
  const isAdmin = user?.role === 'admin';
  const isSuperAdmin = !!superAdminToken || SUPER_ADMIN_EMAILS.includes(user?.email || '');
  
  if (!isAdmin && !isSuperAdmin) {
    return (
      <div className="max-w-4xl mx-auto p-8">
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
          <div className="flex items-center">
            <ShieldExclamationIcon className="h-8 w-8 text-yellow-600 mr-3" />
            <div>
              <h2 className="text-lg font-semibold text-yellow-800">Access Restricted</h2>
              <p className="text-yellow-700 mt-1">
                You need administrator privileges to access this page.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <AdminPanel 
      token={token || ''} 
      userRole={user?.role || ''} 
      userEmail={user?.email || ''}
      superAdminToken={superAdminToken}
    />
  );
};

export default AdminPage;